import script from "./TextCardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TextCardItem.vue?vue&type=script&setup=true&lang=js"

import "./TextCardItem.vue?vue&type=style&index=0&id=040b5090&lang=scss"

const __exports__ = script;

export default __exports__